import script from "./SendNotificationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SendNotificationsPage.vue?vue&type=script&setup=true&lang=js"

import "./SendNotificationsPage.vue?vue&type=style&index=0&id=9e19ac3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e19ac3c"]])

export default __exports__